export default {"src":"/_next/static/media/Clearco-color.16a50c3e.svg","height":25,"width":119};